var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompliant24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6930_30087)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75673 13.5029L3.53333 21H22.5V22.5H3C2.60232 22.4995 2.22105 22.3414 1.93984 22.0602C1.65864 21.7789 1.50046 21.3977 1.5 21V1.5H3V18.8869L6.43755 12.7757C6.54646 12.5787 6.69823 12.4087 6.88164 12.2783C7.06506 12.1478 7.27543 12.0603 7.49723 12.0221C7.71902 11.9839 7.94657 11.996 8.16306 12.0575C8.37955 12.119 8.57945 12.2284 8.748 12.3776L14.3239 17.2456L14.3764 17.1679L19.6264 9.33255L20.873 10.1674L15.645 17.97C15.5367 18.1679 15.3851 18.3387 15.2016 18.4699C15.0181 18.6011 14.8074 18.6892 14.5852 18.7277C14.3629 18.7662 14.1348 18.754 13.9179 18.6922C13.701 18.6303 13.5008 18.5203 13.3323 18.3704L7.75673 13.5029ZM15 1.5H6V3H15V1.5ZM6 4.5H15V6H6V4.5ZM6 7.5H12V9H6V7.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6930_30087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliant24);
export default __webpack_public_path__ + "static/media/Compliant24.5e0f4c9a9676339508d12f9c68d8274f.svg";
export { ForwardRef as ReactComponent };